import request from '../../config/axiosConfig';
import { GET_LIST_SURVEY_FEEDBACKS, UPDATE_SURVEY_FEEDBACK_STATUS } from '../../constants/apiEndPoint';

const feedbackService = {
  getList: async (params) => {
    const { data } = await request({ url: GET_LIST_SURVEY_FEEDBACKS, method: 'POST', data: params });
    return data;
  },

  // Chỉ cập nhật trạng thái xử lý và ghi chú
  update: async (id, dataBody) => {
    const { data } = await request({
      url: UPDATE_SURVEY_FEEDBACK_STATUS,
      method: 'POST',
      data: { id, status: dataBody.status, admin_note: dataBody.admin_note },
    });
    return data;
  },
};

export default feedbackService;
